/**
 * Hero block frontpage
 */
var component_hero_block_frontpage = function(args) {

  // setup args
  var hero = args.hero

  // validate
  if (!hero) {
    console.log('Invalid hero block frontpage');
    return;
  }

  /**
   * Sets teaser titles heights to their current value.
   * This allows them to be animated with the transition CSS property.
   */
  function setTitleHeights() {
    let titles = hero.querySelectorAll('.hero-block__teaser__title');
    titles.forEach(title => {
      title.style.height = 'auto';
      title.style.height = title.offsetHeight + 'px';
    });
  }

  /**
   * Init
   */
  function init_dropdown_menu() {
    setTitleHeights();
  }

  let resizeTimeout;
  // run setTitleHeights() 150ms after window resize (attempt to save processing power)
  window.addEventListener('resize', () => {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
     }
    resizeTimeout = setTimeout(function() {
      setTitleHeights();
    }, 150);
  });

  init_dropdown_menu();

  // make the call chainable
  return this;

};
